import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';

export const Footer = () => {
  const { t } = useTranslation();
  
  const siteName = window.location.hostname.includes('arvorenota10') 
    ? 'arvorenota10.com.br' 
    : 'treerated10.com';

  return (
    <footer className="border-t border-border mt-16 py-8">
      <div className="max-w-4xl mx-auto px-4 text-center space-y-3">
        <p className="text-sm text-muted-foreground">
          {siteName} &copy; 2025
        </p>
        <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
          <Mail className="h-4 w-4" />
          <span>{t('footer.support', 'Support')}:</span>
          <a 
            href="mailto:arvore.velha@seventysete.com"
            className="text-primary hover:underline"
          >
            arvore.velha@seventysete.com
          </a>
        </div>
      </div>
    </footer>
  );
};
